import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { ClientActivityEventType } from '@/lib/types';

/**
 * Logs an entry to the shared 'activityEvents' collection, which feeds the
 * admin Activity page (e.g. login history, content/booking funnel events).
 * Fire-and-forget: failures are logged but never block the caller.
 */
export function logActivityEvent(
  uid: string,
  type: ClientActivityEventType,
  metadata?: Record<string, unknown>
): void {
  if (typeof window === 'undefined') return;

  addDoc(collection(db, 'activityEvents'), {
    type,
    uid,
    metadata: metadata ?? null,
    createdAt: serverTimestamp(),
  }).catch((error) => {
    console.error('[logActivityEvent] Failed to log event:', error);
  });
}
